import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  StackDivider,
  Box,
  Text,
  Image,
  Divider,
  ButtonGroup,
  Button,
  Wrap,
  Center,
  Flex,
  Spacer,
  HStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { cans } from '../icblast.js';

import { transformData } from '../util.js';
import { ServiceCard } from './ServiceCard.js';
import { useParams } from 'react-router-dom';
import { Rating } from './Rating.js';

export function UserPage() {
  let [topServices, setTopServices] = useState([]);
  let [user, setUser] = useState(false);

  let { id } = useParams();

  useEffect(() => {
    (async () => {
      setTopServices([]);
      let r = await cans.qgig.get_user_services(parseInt(id, 10));
      setTopServices(r);
    })();

    (async () => {
      setUser(false);
      let r = await cans.qgig.get_user_info(parseInt(id, 10));
      setUser(r);
    })();
  }, [id]);

  if (!topServices.length) return null;
  if (!user) return null;
  return (
    <Center>
      <Stack maxW="1300px">
        <Stack border="1px" borderRadius="md" borderColor="gray.700" p="3">
          <HStack>
            <Image
              w={'50px'}
              h={'50px'}
              src={user.image_url}
              alt={user.username}
              borderRadius="20px"
            />
            <Stack>
              <Box>{user.username} </Box>
              <Rating value={user.rating} total={user.total_ratings} />
            </Stack>
          </HStack>
          <Box textAlign="left" fontSize="14px" pt="20px" pb="20px">
            {user.about}
          </Box>
        </Stack>
        <Wrap justify="center">
          {topServices.map((x, idx) => (
            <ServiceCard key={idx} {...x} />
          ))}
        </Wrap>
      </Stack>
    </Center>
  );
}
